// ABOUTME: Mobile header for echeck views displayed inside the TabViewBody drawer.
// ABOUTME: Shows a back button, picking job barcode, picker name, and status label.

import { useTheme } from "@emotion/react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import { Box, ButtonBase } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { AMStreamInProrgess } from '../../../../components/global/Modals/ActionModal/AMStream';
import MConfirmation from '../../../../components/global/Modals/MConfirmation';
import SidepanelLoader from '../../../../components/theme/sidepanel2/SidepanelLoader';
import Subheading from "../../../../components/theme/text/Subheading";
import Text from "../../../../components/theme/text/Text";
import { useFindPickingJobMutation } from "../../../../newapi/global/echeckSlice";
import { useOpenPickingJobMutation } from "../../../../newapi/pickingjob/pickingjobSlice";
import { themeSettings, tokens } from "../../../../theme";
import { getPickingJobStateData } from "../../../../utils/labelColorText";
import { general_states } from '../../../../utils/staticEnums';
import { showToastMessageUpdateRequest } from "../../../../utils/toasts";

const SpPickingJobPickingList = SidepanelLoader(() => import("../../../../components/global/Sidepanels/SpPickingJobPickingList/SpPickingJobPickingList"));
const EcheckMobileHeader = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [spLoading, setSpLoading] = useState(false);
    const [isExtended, setIsExtended] = useState(false);

    const [openPickingJob, {isLoading: openPickingJobLoading}] = useOpenPickingJobMutation();
    const [getMyJob] = useFindPickingJobMutation();

    const resetScreen = async () => {
        await getMyJob({
            id: props.incData.pickingJobId,
            workspaceId: props.selectedWorkSpace.id
        }).unwrap()
        .then(result => {
            props.setIncData(result);
            props.setHighlightColor('green');
        })
        .catch(error => {
            props.setHighlightColor('red');
            toast.error(error.data?.message ?? `Er is iets misgegaan`, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        });
    };

    const [amStreamInProgressAnchorEl, setAmStreamInProgressAnchorEl] = useState(null);
    const amStreamInProgressPopoverOpen = Boolean(amStreamInProgressAnchorEl);
    const amStreamInProgressPopoverId = amStreamInProgressPopoverOpen ? 'simple-popover' : undefined;

    const handleAmStreamInProgressPopoverClick = (event) => {
        setAmStreamInProgressAnchorEl(event.currentTarget);
    };

    const handleAmStreamInProgressPopoverClose = () => {
        setAmStreamInProgressAnchorEl(null);
    };

    const [confirmOpenStreamModalOpen, setConfirmOpenStreamModalOpen] = useState(false);
    const confirmOpenStreamModal = {
        open: confirmOpenStreamModalOpen,
        setOpen: setConfirmOpenStreamModalOpen,
    };

    const handleConfirmOpenStreamClose = () => {
        confirmOpenStreamModal.setOpen(false);
    };

    const handleOpenStream = async () => {
        if(openPickingJobLoading) return;
        await openPickingJob(props.incData.pickingJobId)
        .unwrap()
        .then(res => {
            resetScreen();
            showToastMessageUpdateRequest(t,res);
        })
        .catch(error => {
            console.log(error);
            props.setHighlightColor('red');
            toast.error(error.data?.message ??  `Er is iets misgegaan`, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        });
    }
        


    const [jobState,setJobState] = useState(null);
    useEffect(() => {
        setJobState(getPickingJobStateData(props.incData?.pickingJobState,theme));
    },[props.incData])
    return (
        <Box
            sx={{
                p:3,
                py:2,
               
            }}
        >
            <Box
                sx={{
                    px:0.5,
                    borderRadius:5,
                    height:40,
                    display:"flex",
                    alignItems:"center",
                    background: theme.palette.mode === "dark" ? colors[jobState?.labelcolor]?.[100] : colors[jobState?.labelcolor]?.[100],
                }}
            >
                <ButtonBase
                    onClick={props.onBack}
                    sx={{
                        width:32,
                        height:32,
                        borderRadius:"50%",
                        flexShrink:0,
                        color: theme.palette.mode === "dark" ? colors[jobState?.labelcolor]?.[400] : colors[jobState?.labelcolor]?.[400],
                        background: theme.palette.mode === "dark" ? colors[jobState?.labelcolor]?.[100] : colors[jobState?.labelcolor]?.[100],
                    }}
                >
                    <ArrowBackIcon fontSize="small"/>
                </ButtonBase>
                <Box
                    sx={{
                        flex:1,
                        minWidth:0,
                        overflow:'hidden',
                    }}
                >
                     {props.incData?.pickingJobBarcode ?
                        <ButtonBase
                            onClick={() => {
                                setSpLoading(true);
                                setIsExtended(true);
                            }}
                            sx={{
                                display:'flex',
                                flexDirection:"column",
                                alignItems:'flex-start',
                                width:1,
                                overflow:'hidden',
                                // ml:-1,
                                pl:1,
                                borderTopRightRadius:20,
                                borderBottomRightRadius:20,
                                "&:hover" : {
                                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[100],
                                }
                            }}
                        >
                            <Text
                                noBreak
                                bold
                                sx={{
                                    display:"flex",
                                    alignItems:"center",
                                    gap:0.5,
                                    width:1,
                                }}
                            >
                                {props.incData?.pickingJobBarcode}
                                <OpenInNewOutlinedIcon fontSize='13px'/>

                            </Text>
                            <Text noBreak fontSize={13} sx={{ width:1 }}>
                                {props.incData?.pickedBy}
                            </Text>
                        </ButtonBase>
                    :
                        <Box>
                            <Subheading>
                                {t("individual_order")}
                            </Subheading>
                        </Box>
                    }

                </Box>
                {props.incData?.pickingJobState && 
                    <Box
                        sx={{
                            flexShrink:0,
                            ml:1.5,
                            height:32,
                            pl:1.5,
                            pr:0.5,
                            fontSize:14,
                            fontWeight:700,
                            color: theme.palette.mode === "dark" ? colors[jobState?.labelcolor]?.[400] : colors[jobState?.labelcolor]?.[400],
                            border: `1px solid ${theme.palette.mode === "dark" ? colors[jobState?.labelcolor]?.[400] : colors[jobState?.labelcolor]?.[400]}`,
                            display:'flex',
                            alignItems:'center',
                            background: theme.palette.mode === "dark" ? colors[jobState?.labelcolor]?.[100] : colors[jobState?.labelcolor]?.[100],
                            borderRadius:4,
                            gap:1.5,
                            whiteSpace:'nowrap',
                        }}
                    >
                        {t(props.incData?.pickingJobState)}
                        <Box
                            sx={{
                                height:24,
                                borderRadius:4,
                                width:24,
                                display:'flex',
                                alignItems:'center',
                                justifyContent:'center',
                                background: theme.palette.mode === "dark" ? colors[jobState?.labelcolor]?.[400] : colors[jobState?.labelcolor]?.[400],
                            }}
                        >
                            {(props.incData?.pickingJobState === general_states.IN_PROGRESS || props.incData?.pickingJobState === general_states.PICKING_IN_PROGRESS) &&
                                <ButtonBase
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        handleAmStreamInProgressPopoverClick(event);
                                    }}
                                    sx={{
                                        height:24,
                                        width:24,
                                        borderRadius:4,
                                        display:'flex',
                                        alignItems:'center',
                                        justifyContent:'center',
                                    }}
                                >
                                    <MoreVertIcon fontSize="small" sx={{ color: themeSettings(theme.palette.mode).palette[jobState?.labelcolor]?.contrastText }}/>
                                </ButtonBase>
                            }
                            {props.incData?.pickingJobState === general_states.FULLYPICKED &&
                                <ButtonBase
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        confirmOpenStreamModal.setOpen(true);
                                    }}
                                    sx={{
                                        height:24,
                                        width:24,
                                        borderRadius:4,
                                        display:'flex',
                                        alignItems:'center',
                                        justifyContent:'center',
                                    }}
                                >
                                    <LockOpenIcon fontSize="14px" sx={{ color: themeSettings(theme.palette.mode).palette[jobState?.labelcolor]?.contrastText }}/>
                                </ButtonBase>
                            }
                        </Box>
                    </Box>
                }
                {/* <Box sx={{ flex:1 }}>
                    <EcheckOrderListHeader
                        incData={props.incData}
                        setHighlightColor={props.setHighlightColor}
                    />
                </Box> */}
            </Box>
            <MConfirmation
                open={confirmOpenStreamModal.open}
                handleClose={handleConfirmOpenStreamClose}
                title={t("open_pickingjob_title")}
                subtitle={t("open_pickingjob_subtitle")}
                confirm={() => handleOpenStream(true)}
            />

            <AMStreamInProrgess
                id={amStreamInProgressPopoverId}
                open={amStreamInProgressPopoverOpen}
                anchorEl={amStreamInProgressAnchorEl}
                onClose={handleAmStreamInProgressPopoverClose}
                setHighlightColor={props.setHighlightColor}
                item={{ id: props.incData?.pickingJobId }}
                refetchJobs={props.refetchJobs}
                onBack={props.onBack}
                resetScreen={resetScreen}
                activateStreamPanel={(tab) => {
                    setSpLoading(true);
                    setIsExtended(true);
                }}
            />

            {spLoading &&
                <SpPickingJobPickingList
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    pickingJobListId={props.incData?.pickingJobId}
                    // data={streamData} 
                /> 
            }
        </Box>
    );
};

export default EcheckMobileHeader;
